import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HotelPanel from '../HotelPanel';
import { Cross } from '../../utils';
import { updateProductPrice } from '../../redux/actions';

import {
  BriefHotelInfo,
  BriefColumn,
  BriefStarsContainer,
  BriefStars,
  Price,
  OldPrice,
  BriefButton,
  ModalContainer,
  ModalButton,
} from './styles';

const mapStateToProps = state => ({
  product: state.userProduct.product,
  loadingPrice: state.userProduct.product.price.isFetching,
  initialDate: state.userPreferences.date,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleInitialDate: updateProductPrice,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class HotelPanelMobile extends Component {
  static propTypes = {
    rating: PropTypes.number,
    totalReviews: PropTypes.number,
    initialDate: PropTypes.string,
    handleInitialDate: PropTypes.func,
    product: PropTypes.instanceOf(Object),
    tax: PropTypes.number,
    loadingPrice: PropTypes.bool,
  };

  state = {
    isModalOpen: false,
  };

  componentDidMount() {
    const { initialDate, handleInitialDate } = this.props;
    handleInitialDate(initialDate);
  };

  toggleModal = () => {
    this.setState(prevState => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  };

  render() {
    const { isModalOpen } = this.state;
    const {
      rating,
      totalReviews,
      product,
      tax,
      loadingPrice
    } = this.props;
    const { price } = product;
    const { newPrice, oldPrice } = price;

    return (
      <BriefHotelInfo>
        <BriefColumn blured={loadingPrice}>
          {newPrice < oldPrice && (
            <Fragment>
              <OldPrice>
                ${oldPrice}
              </OldPrice>
              <Price yellowBack>
                ${newPrice}
                <span>/guest</span>
              </Price>
            </Fragment>
          ) || (
            <Price>
              ${newPrice}
              <span>/guest</span>
            </Price>
          )}
          <BriefStarsContainer>
            <BriefStars>{totalReviews}</BriefStars>
            <StarRatings rating={rating === 0 ? 5 : rating} numberOfStars={5} starRatedColor="#1eb6ff" starEmptyColor="#b6e4f9" starDimension="15px" starSpacing="0px" />
          </BriefStarsContainer>
        </BriefColumn>
        <BriefColumn>
          <BriefButton btnType="primary" type="button" onClick={this.toggleModal}>
            Book
          </BriefButton>
        </BriefColumn>
        {isModalOpen && (
          <ModalContainer>
            <ModalButton onClick={this.toggleModal}>
              <Cross width={17} height={17} />
            </ModalButton>
            <HotelPanel {...this.props} tax={tax} />
          </ModalContainer>
        )}
      </BriefHotelInfo>
    );
  }
}

export default HotelPanelMobile;
